// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"205":"post","624":"catalog","937":"member"}[chunkId] + "." + {"205":"690a9bdd","624":"a2df2eba","937":"563c0cf8"}[chunkId] + ".css";
};